import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../../../../infrastructure/redux/store';

import {
  AlocacaoPageQuery_cursos_ofertas,
  AlocacaoPageQuery_periodos,
} from '../../../../graphql/queries/__generated__/AlocacaoPageQuery';

import { Container, Input, Oferta } from './styles';
import { useAlocacoesLazyQuery } from '../../../../graphql/queries/alocacoes.query';
import { desselecionarTurma, selecionarTurma } from '../../../../reducers/alocacao.reducer';
import { sigla } from '../../../../../shared/utils/formatters/sigla.formatter';

interface Props {
  ofertas: AlocacaoPageQuery_cursos_ofertas[];
  periodo: AlocacaoPageQuery_periodos | null;
  dsc_nome_curso: string | null;
  dsc_sigla_curso: string | null;
  ativa: boolean;
}

interface IParamsAlternarGrade {
  id_oferta: number;
  id_turma: number;
  num_oferta: number | null;
  num_turma: number;
  ativar: boolean;
}

const Ofertas: React.FC<Props> = (props) => {
  const { grades } = useSelector((state: RootState) => state.alocacao);

  const dispatch = useDispatch();

  const [obter_alocacoes, { data, refetch: refetch_obter_alocacoes }] = useAlocacoesLazyQuery();

  const alternar_grade = async (params: IParamsAlternarGrade) => {
    if (!props.periodo) return;

    const id_grade = `${params.id_oferta}.${params.id_turma}`;

    if (!params.ativar) {
      dispatch(desselecionarTurma(id_grade));
      return;
    }

    const { data: response } = data
      ? await refetch_obter_alocacoes({
          id_oferta: params.id_oferta,
          id_turma: params.id_turma,
          dat_inicio: props.periodo.dat_inicio,
          dat_fim: props.periodo.dat_fim,
        })
      : await obter_alocacoes({
          variables: {
            id_oferta: params.id_oferta,
            id_turma: params.id_turma,
            dat_inicio: props.periodo.dat_inicio,
            dat_fim: props.periodo.dat_fim,
          },
        });

    if (!response) return;

    const sigla_curso = sigla(props.dsc_nome_curso, props.dsc_sigla_curso);

    const grade = {
      id_grade,
      id_oferta: params.id_oferta,
      id_turma: params.id_turma,
      id_periodo: props.periodo.id_periodo,
      dsc_nome_grade: `${sigla_curso} ${params.num_oferta}.${params.num_turma}`,
      alocacoes: response.alocacoes_professores || [],
      feriados: response.feriados || [],
      dat_inicio: props.periodo.dat_inicio,
      dat_fim: props.periodo.dat_fim,
    };

    dispatch(selecionarTurma(grade));
  };

  const obter_id_grade = (id_oferta: number | null, id_turma: number | null) => {
    return `${id_oferta}.${id_turma}`;
  };

  const obter_numero_grade = (num_oferta: number | null, num_turma: number | null) => {
    return `${num_oferta}.${num_turma}`;
  };

  const turmasRenderizadas = props.ofertas
    .filter((oferta) => (props.ativa ? oferta.ativa : true))
    .flatMap((oferta) =>
      oferta.turmas.map((turma) => ({ oferta, turma }))
    )
    .sort((a, b) => {
      const numOfertaA = a.oferta.num_oferta ?? 0;
      const numOfertaB = b.oferta.num_oferta ?? 0;
      if (numOfertaA !== numOfertaB) {
        return numOfertaA - numOfertaB;
      }
      const numTurmaA = a.turma.num_turma ?? 0;
      const numTurmaB = b.turma.num_turma ?? 0;
      return numTurmaA - numTurmaB;
    });

  return (
    <Container>
      {turmasRenderizadas.map(({ oferta, turma }) => (
        <Fragment key={obter_id_grade(oferta.id_oferta, turma.id_turma)}>
          <Input
            id={obter_id_grade(oferta.id_oferta, turma.id_turma)}
            name={oferta.id_oferta.toString()}
            disabled={!props.periodo}
            onChange={(e) =>
              alternar_grade({
                id_oferta: oferta.id_oferta,
                id_turma: turma.id_turma,
                num_oferta: oferta.num_oferta,
                num_turma: turma.num_turma,
                ativar: e.target.checked,
              })
            }
            checked={Boolean(
              grades.find(
                (g) => g.id_grade === obter_id_grade(oferta.id_oferta, turma.id_turma)
              )
            )}
          />
          <Oferta
            color={String(oferta.num_oferta)}
            htmlFor={obter_id_grade(oferta.id_oferta, turma.id_turma)}
          >
            {obter_numero_grade(oferta.num_oferta, turma.num_turma)}
          </Oferta>
        </Fragment>
      ))}
    </Container>
  );
};

export { Ofertas };
export type { Oferta };
